import { RouteConfig } from "vue-router";
import sellRoutes from "@/modules/sell/routes";
import transactionRoutes from "@/modules/transactions/routes";
import referralRoutes from "@/modules/referrals/routes";
import walletRoutes from "@/modules/wallets/routes";
import securityRoutes from "@/modules/security/routes";
import bankRoutes from "@/modules/banks/routes";
import Profile from "./views/profile/Profile";
import HelpCenter from "./views/help-center/HelpCenter";
import Dashboard from "./views/dashboard/Dashboard";

export default [
  {
    path: "/dashboard",
    component: Dashboard,
    meta: { requiresAuth: true, title: "Dashboard" },
    redirect: "/dashboard/sell",
    children: [
      ...sellRoutes,
      ...transactionRoutes,
      // ...walletRoutes,
      ...securityRoutes,
      ...referralRoutes,
      ...bankRoutes,
      {
        path: "/dashboard/profile",
        component: Profile,
        meta: { title: "Profile" },
      },
      {
        path: "/dashboard/help",
        component: HelpCenter,
        meta: { title: "Help Center" },
      },
    ],
  },
] as RouteConfig[];
